<template lang="pug">
.l-debug(
  v-if="store.ui.state.debug"
)
  //- .l-debug__maptype
  //-   //- 1:広域,2:山頂本堂中域,3:山頂本堂詳細,4:鳳凰殿中域,5:鳳凰殿詳細
  //-   .l-debug__maptype__item(
  //-     :class="{active:store.ui.state.maptype == 1}"
  //-     @click="clickMaptype(1)"
  //-   ) 広域
  //-   .l-debug__maptype__item(
  //-     :class="{active:store.ui.state.maptype == 2}"
  //-     @click="clickMaptype(2)"
  //-   ) 山頂本堂中域
  //-   .l-debug__maptype__item(
  //-     :class="{active:store.ui.state.maptype == 3}"
  //-     @click="clickMaptype(3)"
  //-   ) 山頂本堂詳細
  //-   .l-debug__maptype__item(
  //-     :class="{active:store.ui.state.maptype == 4}"
  //-     @click="clickMaptype(4)"
  //-   ) 鳳凰殿中域
  //-   .l-debug__maptype__item(
  //-     :class="{active:store.ui.state.maptype == 5}"
  //-     @click="clickMaptype(5)"
  //-   ) 鳳凰殿詳細

  //- .l-debug__season
  //-   //- 1:春,2:夏,3:秋,4:冬
  //-   .l-debug__season__item(
  //-     :class="{active:store.ui.state.season == 1}"
  //-     @click="clickSeason(1)"
  //-   ) 春
  //-   .l-debug__season__item(
  //-     :class="{active:store.ui.state.season == 2}"
  //-     @click="clickSeason(2)"
  //-   ) 夏
  //-   .l-debug__season__item(
  //-     :class="{active:store.ui.state.season == 3}"
  //-     @click="clickSeason(3)"
  //-   ) 秋
  //-   .l-debug__season__item(
  //-     :class="{active:store.ui.state.season == 4}"
  //-     @click="clickSeason(4)"
  //-   ) 冬
  
  .l-debug__tutorial
    .l-debug__tutorial__item(
      :class="{active:store.ui.state.tutorial.done}"
      @click="clickTutorial(0)"
    ) チュートリアル 済
    

  .l-debug__hotoke
    .l-debug__hotoke__item.red(
      @click="clickHotoke(0)"
    ) 仏 0
    .l-debug__hotoke__item.red(
      @click="clickHotoke(7)"
    ) 仏 7
    .l-debug__hotoke__item.red(
      @click="clickHotoke(8)"
    ) 仏 8

  .l-debug__kumoMotion
    .l-debug__kumoMotion__item(
      :class="{active:store.ui.state.kumoMotion == 0}"
      @click="clickKumoMotion(0)"
    ) 雲 0
    .l-debug__kumoMotion__item(
      :class="{active:store.ui.state.kumoMotion == 1}"
      @click="clickKumoMotion(1)"
    ) 雲 1
    .l-debug__kumoMotion__item(
      :class="{active:store.ui.state.kumoMotion == 2}"
      @click="clickKumoMotion(2)"
    ) 雲 2

  .l-debug__introMotion
    .l-debug__introMotion__item(
      :class="{active:store.ui.state.introMotion == 0}"
      @click="clickIntroMotion(0)"
    ) イントロ 0
    .l-debug__introMotion__item(
      :class="{active:store.ui.state.introMotion == 1}"
      @click="clickIntroMotion(1)"
    ) イントロ 1
    .l-debug__introMotion__item(
      :class="{active:store.ui.state.introMotion == 2}"
      @click="clickIntroMotion(2)"
    ) イントロ 2
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-debug
  posfb(20px,20px,10)
  &__tutorial,
  &__hotoke,
  &__maptype,
  &__season,
  &__kumoMotion,
  &__introMotion
    margin-bottom 25px
    &__item
      font-size 12px
      background-color #333
      border-radius 5px
      height 20px
      line-height 20px
      width 110px
      color #FFF
      text-align center
      margin-top 5px
      cursor pointer
      &.green
        background-color #64ba49
      &.red
        background-color #dd4517
      &.active
        background-color #0CC
      &:first-child
        margin-top 0
  

</style>


<script>
import { defineComponent,onMounted } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  name:'Debug',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    onMounted(()=>{
    })

    const clickMaptype = (maptype) =>{
      // store.ui.state.maptype = maptype
      router.push('/map'+maptype)
    }
    const clickSeason = (season) =>{
      store.ui.state.season = season
    }
    const clickHotoke = (count) =>{
      store.ui.clearHotoke()
      const dummyIds = [999990,999991,999992,999993,999994,999995,999996,999997,999998,999999,9999910,9999911]
      for(let i=0;i<count;i++){
        store.ui.updateHotoke(dummyIds[i])
      }
    }
    const clickKumoMotion = (kumoMotion) =>{
      store.ui.state.kumoMotion = kumoMotion
    }
    const clickIntroMotion = (introMotion) =>{
      store.ui.state.introMotion = introMotion
    }

    const clickTutorial = () =>{
      if(store.ui.state.tutorial.done){
        store.ui.clearTutorial()
      } else {
        store.ui.updateTutorial()
      }
    }
    

    return{
      store,
      clickMaptype,
      clickSeason,
      clickHotoke,
      clickKumoMotion,
      clickIntroMotion,
      clickTutorial
    }
  }
})
</script>
